import * as React from 'react';
import { __ } from '@bart.sk-eshop/react-i18n';
import styled from 'styled-components';
import { rem } from 'polished';
import { CheckboxStyled } from '../../components/_helpers/form/Checkbox';
import { cookieAgree, cookieDisagree } from '../../utilities';
import * as cookie from 'react-cookies';
import PageCta from '../../components/_helpers/Cta/PageCta';

const Wrapper = styled.div``;

const CustomCheckboxStyled = styled(CheckboxStyled)`
  display: block;
  /* The hidden checkbox input sits between the labels in the DOM, so use the
     general sibling combinator instead of the adjacent one. */
  & ~ & {
    margin-top: ${rem(12)};
  }
`;

const CookiesChooser = () => {
  const onAgreeClick = () => {
    cookieAgree();
    if (window && window.location) {
      window.location.href = window.location.href;
    }
  };

  const onDisagreeClick = () => {
    cookieDisagree();
    if (window && window.location) {
      window.location.href = window.location.href;
    }
  };

  return (
    <Wrapper>
      <CustomCheckboxStyled
        name="cookie_setup"
        id="cookie_setup"
        value={
          cookie.load('COOKIES_REJECT') === 0 ||
          cookie.load('COOKIES_REJECT') === '0'
            ? '1'
            : '0'
        }
        checked={
          cookie.load('COOKIES_REJECT') === 0 ||
          cookie.load('COOKIES_REJECT') === '0'
            ? true
            : false
        }
        onChange={() => {
          cookie.load('COOKIES_REJECT') === 0 ||
          cookie.load('COOKIES_REJECT') === '0'
            ? onDisagreeClick()
            : onAgreeClick();
        }}
      >
        {__(
          'Súhlasím so spracovaním analytických a reklamných cookies a cookies tretích strán.',
        )}
      </CustomCheckboxStyled>

      <CustomCheckboxStyled
        disabled={true}
        name="cookie_setup_mandatory"
        id="cookie_setup_mandatory"
        value={'1'}
        checked={1}
      >
        {__('Nevyhnutné - Základné súbory cookies')}
      </CustomCheckboxStyled>

      <PageCta text={__('Navštíviť e-shop')} url="/" />
    </Wrapper>
  );
};

export default CookiesChooser;
